import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-time-warning',
  templateUrl: './time-warning.component.html',
  styleUrls: ['./time-warning.component.scss']
})
export class TimeWarningComponent implements OnInit {

  constructor(public dataSvc: DataService,
    public translate: TranslateService) { 
      if(dataSvc != null && dataSvc !== undefined){
        var usersLanguage = dataSvc.currentUser.Language.DotNetCulture.toString().substring(0,2);
        if(usersLanguage != null){
          translate.setDefaultLang(usersLanguage);
          translate.use(usersLanguage);
        }
        else{
          translate.setDefaultLang('en');
          translate.use('en');
        }
      }
      else{
        translate.setDefaultLang('en');
        translate.use('en');
      }
    }

  ngOnInit() {
  }

}
